/**
 * @generated SignedSource<<9a97009c04791d49ffd8fef931f1bb61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusWidgetHomeV2Query$data = {
  readonly dailyPulseArticles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly " $fragmentSpreads": FragmentRefs<"plusWidgetArticleHomeV2">;
      };
    }>;
  };
  readonly plusArticles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly " $fragmentSpreads": FragmentRefs<"plusWidgetArticleHomeV2">;
      };
    }>;
  };
  readonly " $fragmentType": "plusWidgetHomeV2Query";
};
export type plusWidgetHomeV2Query$key = {
  readonly " $data"?: plusWidgetHomeV2Query$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetHomeV2Query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "typeIds": [
    "09ecd76b-0271-467d-be05-c228b9a8ef47"
  ]
},
v1 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": {
    "direction": "DESC",
    "field": "PUBLISHED_DATE"
  }
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ArticleEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Article",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "entityId",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "plusWidgetArticleHomeV2"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusWidgetHomeV2Query",
  "selections": [
    {
      "alias": "dailyPulseArticles",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": (v0/*: any*/)
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        (v1/*: any*/)
      ],
      "concreteType": "ArticleConnection",
      "kind": "LinkedField",
      "name": "articles",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": "articles(filter:{\"typeIds\":[\"09ecd76b-0271-467d-be05-c228b9a8ef47\"]},first:1,orderBy:{\"direction\":\"DESC\",\"field\":\"PUBLISHED_DATE\"})"
    },
    {
      "alias": "plusArticles",
      "args": [
        {
          "kind": "Literal",
          "name": "exclude",
          "value": (v0/*: any*/)
        },
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "paywallTypeIds": [
              "716f570e-3083-4138-a080-47d3830fafe3"
            ]
          }
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 2
        },
        (v1/*: any*/)
      ],
      "concreteType": "ArticleConnection",
      "kind": "LinkedField",
      "name": "articles",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": "articles(exclude:{\"typeIds\":[\"09ecd76b-0271-467d-be05-c228b9a8ef47\"]},filter:{\"paywallTypeIds\":[\"716f570e-3083-4138-a080-47d3830fafe3\"]},first:2,orderBy:{\"direction\":\"DESC\",\"field\":\"PUBLISHED_DATE\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "13b97071c4ac26d3a5ee4bad121bdcd9";

export default node;
